import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { UserDisplay } from '../../../../pages/users/types/UserDisplay';
import './DeleteUserModal.css';

interface DeleteUserModalProps {
  isOpen: boolean;
  user: UserDisplay | null;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CONFIRMATION_TEXT = 'SUPPRIMER';

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  user,
  isLoading = false,
  onCancel,
  onConfirm,
}) => {
  const [confirmationInput, setConfirmationInput] = useState('');

  // Ajuste pendant le rendu (pattern « ajuster l'etat quand une prop change » de
  // la doc React) : dans un effet, ce recalcul coutait un second rendu.
  const [wasOpen, setWasOpen] = useState(isOpen);
  if (isOpen !== wasOpen) {
    setWasOpen(isOpen);
    if (!isOpen) setConfirmationInput('');
  }

  if (!user) return null;

  const isConfirmEnabled = confirmationInput === CONFIRMATION_TEXT;

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      width={612}
      className="delete-user-modal"
      closable={false}
    >
      <div className="delete-user-modal__content">
        <div className="delete-user-modal__header">
          <CloseCircleFilled className="delete-user-modal__icon" />
          <h3 className="delete-user-modal__title">Supprimer l'utilisateur de la Compagnie ?</h3>
        </div>

        <p className="delete-user-modal__description">
          Cette action est réversible. <strong>{user.name}</strong> pourra toujours être réinvité via la même adresse mail.
        </p>

        {/* <p className="delete-user-modal__description">
          Cette action est irréversible. <strong>{user.name}</strong> sera supprimée définitivement.
        </p> */}

        {/* <div className="delete-user-modal__info-box">
          <h4 className="delete-user-modal__info-title">Cette action va définitivement :</h4>
          <ul className="delete-user-modal__info-list">
            <li>Supprimer toutes les données et l'historique utilisateur</li>
            <li>Libérer tout numéro de téléphone assigné</li>
            <li>Supprimer tous les enregistrements d'appels et leurs transcriptions</li>
            <li>Annuler tous les crédits restants (non remboursables)</li>
          </ul>
        </div> */}

        <div className="delete-user-modal__confirmation">
          <p className="delete-user-modal__confirmation-label">
            Tapez <strong>SUPPRIMER</strong> pour confirmer
          </p>
          <Input
            value={confirmationInput}
            onChange={(e) => setConfirmationInput(e.target.value)}
            placeholder="SUPPRIMER"
            className="delete-user-modal__confirmation-input"
          />
        </div>

        <div className="delete-user-modal__actions">
          <Button className="delete-user-modal__cancel-btn" onClick={onCancel}>
            Annuler
          </Button>
          <Button
            type="primary"
            danger
            className="delete-user-modal__confirm-btn"
            onClick={onConfirm}
            loading={isLoading}
            disabled={!isConfirmEnabled}
          >
            Supprimer
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
